<template>
  <div class="slider">
    <b-carousel id="carousel-fade" class="main-slider" fade indicators controls>
      <div class="carousel-inner">
        <div class="carousel-item" v-for="data in sliderItems" :key="data.title">
          <div class="row">
            <div class="d-none d-md-block col-md-6">
              <div class="carousel-caption main-slider-caption">
                <h5
                  class="main-slider-title animated fadeInUp"
                  style="animation-delay:.4s;"
                >{{data.title}}</h5>
                <p
                  class="main-slider-description animated fadeInUp"
                  style="animation-delay:.7s;"
                >{{data.description}}</p>
                <router-link
                  class="main-slider-btn animated zoomIn"
                  style="animation-delay: .4s;"
                  router
                  :to="data.link"
                >მეტის ნახვა</router-link>
              </div>
            </div>
            <div class="col-12 col-md-6">
              <div class="main-slider-bg">
                <img class="main-slider-image animated zoomIn" v-bind:src="data.image" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-carousel>

    <div class="colourful-boxes">
      <div class="colourful-box colourful-box-sm colourful-box-yellow" v-rellax="rellaxMin1"></div>
      <div
        class="colourful-box colourful-box-md colourful-box-swampColor d-none d-md-block"
        v-rellax="rellax1"
      ></div>
      <div
        class="colourful-box colourful-box-md colourful-box-bw d-none d-md-block"
        v-rellax="rellax1"
      ></div>
      <div class="colourful-box colourful-box-square colourful-box-bp" v-rellax="rellaxMin1"></div>
      <div
        class="colourful-box colourful-box-square-lg colourful-box-bp d-none d-md-block"
        v-rellax="rellax2"
      ></div>
      <div class="colourful-box colourful-box-square colourful-box-yellow" v-rellax="rellax3"></div>
      <div class="colourful-box colourful-box-sm colourful-box-white" v-rellax="rellax2"></div>
      <div class="colourful-circle grey" v-rellax="rellax3">
        <img class="dots" src="../assets/images/dots.svg" alt />
      </div>
      <div class="colourful-circle bb" v-rellax="rellaxMin2"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "slider",
  data() {
    return {
      sliderItems: [
        {
          image: require("../assets/images/ace3.jpg"),
          title: "დეკორატიული კოსმეტიკა",
          description:
            "რაც მეტია დეკორატიულ კოსმეტიკაში ნატურალური კომპონენტი, მით მეტად ხარისხიანი და უსაფრთხოა. ხარისხიანი ნატურალური კოსმეტიკის შემადგენლობაში არ უნდა იყოს ალერგიული რეაქციის, გაღიზიანების ან კომედონების გამომწვევი კომპონენტები.",
          link: "/cosmetics"
        },
        {
          image: require("../assets/images/5.jpg"),
          title: "სახის მოვლა",
          description:
            "სახის კანი იდეალურად რომ გამოიყურებოდეს, მას რეგულარული და სწორი მოვლა სჭირდება. მნიშვნელობა არ აქვს როგორი ხარისხის კოსმეტიკას ან დამატენიანებელს/მკვებავს გამოიყენებთ, თუ დემაკიაჟს და სახის გასუფთავებას სათანადო ყურადღებას არ დაუთმობთ. ",
          link: "/skincare"
        },
        {
          image: require("../assets/images/VsShimmer1.jpg"),
          title: "ტანის მოვლა",
          description:
            "ტანის კანს ისეთივე სათუთი მოვლა სჭირდება, როგორც სახის კანს - რეგულარულად გამოიყენეთ სკრაბი, დაიტენიანეთ და დაიცავით მზის გამოსხივებისგან.",
          link: "/bodycare"
        }
      ],
      rellaxMin4: {
        speed: -4
      },
      rellaxMin3: {
        speed: -3
      },
      rellaxMin2: {
        speed: -2
      },
      rellaxMin1: {
        speed: -1
      },
      rellax1: {
        speed: 1
      },
      rellax2: {
        speed: 2
      },
      rellax3: {
        speed: 3
      },
      rellax4: {
        speed: 4
      }
    };
  }
};
</script>

<style lang="scss">
@import "~@/styles/global";

.main-slider {
  width: 100%;
  position: relative;
  margin-top: 16vh;
  &-bg {
    width: 100%;
    height: 70vh;
    padding: 2vh;
    clip-path: polygon(
      0% 15%,
      15% 15%,
      15% 0%,
      85% 0%,
      100% 0,
      100% 15%,
      100% 85%,
      100% 100%,
      85% 100%,
      15% 100%,
      15% 85%,
      0% 85%
    );
    background: $greyDark;
  }
  &-image {
    width: 100%;
    height: 100%;
    display: block;
    object-fit: cover;
  }
  &-caption {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    height: 100%;
    padding-top: 12vh;
  }
  &-btn {
    border: 1px solid $skyblueLight;
    background-color: transparent;
    color: $skyblueLight;
    padding: 3vh 0;
    text-decoration: none;
    box-shadow: 3px 3px 8px rgba(127, 209, 216, 0.6);
    transition: 0.5s;
    width: 32vh;
    position: absolute;
    bottom: 15vh;
    left: 50%;
    transform: translateX(-50%);
    font-family: $fontALKSanet;
    font-size: $font-sm;
    letter-spacing: 0.4vh;
    &:hover {
      text-decoration: none;
      color: $purple;
      border-color: $purple;
      box-shadow: 3px 3px 8px rgba(160, 137, 147, 0.9);
    }
  }
  &-title {
    font-size: $font-xl;
    color: $skyblueLight;
    font-family: $fontALKSanet;
  }
  &-description {
    color: $greyLight;
    font-size: $font-md;
    font-family: $fontDejaVuSans;
  }
  .carousel-indicators {
    flex-direction: column;
    align-items: center;
    bottom: 1vh;
    left: auto;
    right: 34%;

    li {
      width: 2vh;
      height: 2vh;
      background-color: $skyblueLight;
      &:focus {
        outline: none;
      }
    }
  }
}

.colourful {
  &-circle {
    width: 40vh;
    height: 40vh;
    border-radius: 50%;
    &.grey {
      border: 1px dashed $grey;
      position: absolute;
      left: -16vh;
      top: 14vh;
      .dots {
        height: 20vh;
        position: absolute;
        left: 20vh;
        top: 8vh;
      }
    }
    &.bb {
      border: 1px solid #e0fefe;
      position: absolute;
      top: 17vh;
      right: 0;
      box-shadow: 0px -3px 7px 0px rgba(127, 209, 216, 0.6);
    }
  }
  &-box {
    margin: 5vh;
    &-sm {
      width: 9vh;
      height: 14vh;
    }
    &-md {
      width: 10vh;
      height: 22vh;
    }
    &-lg {
      width: 18vh;
      height: 28vh;
    }
    &-square {
      width: 18vh;
      height: 18vh;
      &-lg {
        width: 39vh;
        height: 39vh;
      }
    }
    &-yellow {
      background-color: $yellow;
    }
    &-swampColor {
      background-color: $swampColor;
    }
    &-blue {
      background-color: $skyblue;
    }
    &-white {
      background-color: $white;
    }
    &-bw {
      border: 3px solid $white;
    }
    &-bp {
      border: 1px solid $pink;
      box-shadow: 3px 3px 8px rgba(255, 197, 196, 0.6);
      transition: 0.3s;
    }
    &:nth-child(1) {
      position: absolute;
      right: 10vh;
      top: 19vh;
      z-index: 1;
    }
    &:nth-child(2) {
      position: absolute;
      top: 115vh;
      right: 20vh;
      z-index: 1;
    }
    &:nth-child(3) {
      position: absolute;
      top: 108vh;
      right: 13vh;
      z-index: 1;
    }
    &:nth-child(4) {
      position: absolute;
      left: 45%;
      top: 46%;
      z-index: 1;
    }
    &:nth-child(5) {
      position: absolute;
      left: 41%;
      top: 18%;
      z-index: 1;
    }
    &:nth-child(6) {
      position: absolute;
      left: -5%;
      top: 96vh;
      z-index: 1;
    }
    &:nth-child(7) {
      position: absolute;
      left: 4%;
      top: 100vh;
      z-index: 1;
    }
  }
}

.opacity-animation {
  animation-name: opacity-an;
}
@keyframes opacity-an {
  0% {
    opacity: 0;
  }
  50% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
/* =========== Responsive */

@media screen and (min-width: 768px) {
  .main-slider {
    &-bg {
      padding: 12vh;
      height: 90vh;
    }
    .carousel-indicators {
      li {
        width: 4vh;
        height: 4vh;
      }
    }
  }
  .colourful-box {
    &:nth-child(6) {
      left: 2%;
      top: 120vh;
    }
    &:nth-child(7) {
      top: 125vh;
    }
  }
}
</style>